import { render, staticRenderFns } from "./SettingsGasPrice.vue?vue&type=template&id=5a11d9b5&scoped=true&"
import script from "./SettingsGasPrice.vue?vue&type=script&lang=js&"
export * from "./SettingsGasPrice.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGasPrice.vue?vue&type=style&index=0&id=5a11d9b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a11d9b5",
  null
  
)

export default component.exports